export default __webpack_public_path__ + "static/media/58_mobile.d0f37399.jpg";